import { memo } from 'react'
import { shallow } from 'zustand/shallow'
import { useReportStore } from '@/modules/report/useReportsStore'
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from '@/modules/shared/components/ui/table'
import { Card, CardContent, CardHeader, CardTitle } from '@/modules/shared/components/ui/card'
import { priceFormatter } from '@/modules/shared/utils/formatter'

export default memo(function ListSalesByClientReport() {
	const { loading, jsonSalesByClient } = useReportStore(
		(state) => ({
			loading: state.loading,
			jsonSalesByClient: state.jsonSalesByClient,
		}),
		shallow,
	)

	const totalValue = jsonSalesByClient?.clientes?.reduce(
		(acc, item) => acc + (Number(item.valor) || 0),
		0,
	) || 0

	return (
		<div>
			{!loading && jsonSalesByClient?.clientes?.length > 0 && (
				<Card>
					<CardHeader>
						<CardTitle className="text-lg">Lista Cliente x Valor</CardTitle>
					</CardHeader>
					<CardContent>
						{/* Mobile view: Cards */}
						<div className="md:hidden space-y-4">
							<Card>
								<CardContent className="pt-4">
									<p className="font-bold text-right">Total:</p>
									<div className="mt-2 text-sm">
										<p>Valor: {priceFormatter.format(totalValue)}</p>
									</div>
								</CardContent>
							</Card>
							{jsonSalesByClient?.clientes?.map((item) => (
								<Card key={item.cnpjCpf}>
									<CardContent className="pt-4">
										<p className="font-bold">{item.nome}</p>
										<div className="mt-2 space-y-1 text-sm">
											<p>CNPJ/CPF: {item.cnpjCpf}</p>
											<p>Valor: {priceFormatter.format(item.valor)}</p>
										</div>
									</CardContent>
								</Card>
							))}
						</div>

						{/* Desktop view: Table */}
						<div className="hidden md:block">
							<Table>
								<TableHeader>
									<TableRow>
										<TableHead>Nome</TableHead>
										<TableHead>CNPJ/CPF</TableHead>
										<TableHead>Valor</TableHead>
									</TableRow>
								</TableHeader>
								<TableBody>

									{jsonSalesByClient?.clientes?.map((item) => (
										<TableRow key={item.cnpjCpf}>
											<TableCell className="font-bold">{item.nome}</TableCell>
											<TableCell>{item.cnpjCpf}</TableCell>
											<TableCell>{priceFormatter.format(item.valor)}</TableCell>
										</TableRow>
									))}
									<TableRow>
										<TableCell colSpan={2} className="text-right font-bold">
											Total:
										</TableCell>
										<TableCell className="font-bold">{priceFormatter.format(totalValue)}</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</div>
					</CardContent>
				</Card>
			)}
		</div>
	)
})